import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "react-step-progress-bar/styles.css";
import { getNotifications, updateNotificationCard } from "../redux/actions/dataActions";


const styles = {
  root: {
    minWidth: "325px",
  },
  center: {
    padding: "2em auto 2em auto",
    minWidth: "325px",
  },
  containerCentral: {
    justifyContent: "center",
  },
  lightText: {
    fontWeight: "100",
  },
  card: { margin: "1.5em auto 1.5em auto" },
};

class notifications extends Component {
  componentDidMount() {
    this.props.getNotifications();
  }

  updateNotificationCard = (dayId, isRead) => {
    this.props.updateNotificationCard({dayId, isRead});
  };

  render() {

    const { notifications,loading } = this.props.data;
    const { classes } = this.props;

    let notificationsList;
    if (loading) {
      notificationsList = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      );
    } else {
      if (notifications.length > 0) {
        notificationsList = notifications.map((notification, i) => {
          // hide due date when falsy
          const dueDate = notification.dueDate ? (
            <Typography variant="h5" gutterBottom>
              Due date: {notification.dueDate}
            </Typography>
          ) : (
            <Typography/>
          )

          return <Card variant="outlined" className="classes.card" key={i}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {notification.title}
              </Typography>
              { dueDate }
              <FormControlLabel
                key={notification.message}
                name={notification.message}
                type="checkbox"
                labelPlacement="end"
                label={<span
                          onClick={this.contentClickHandler}
                          dangerouslySetInnerHTML={{ __html: notification.message }}
                        />}
                control={
                  <Checkbox
                    key={i}
                    color="primary"
                    name="a"
                    onClick={()=>this.updateNotificationCard(notification.day, Math.abs(notification.isRead-1))}
                  />
                }
              />
            </CardContent>
          </Card>
        });
      } else {
        notificationsList = (
          <Fragment>
            <Typography variant="h4">
              You don't have any notifications
            </Typography>
          </Fragment>
        );
      }
    }

    return (
      <Grid container className={classes.containerCentral}>
        <Grid item sm />
        <Grid item sm className={classes.center}>
          <Typography variant="h3">My Notifications</Typography>
          {notificationsList}
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

notifications.propTypes = {
  getNotifications: PropTypes.func.isRequired,
  updateNotificationCard: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { getNotifications, updateNotificationCard })(
  withStyles(styles)(notifications)
);
